import api from './api';
import { Cart, ApiResponse } from '../types';

export const cartService = {
  getCart: () => api.get<ApiResponse<Cart>>('/cart'),
  addItem: (productId: string, quantity = 1) => api.post<ApiResponse<Cart>>('/cart/items', { productId, quantity }),
  updateItem: (id: string, quantity: number) => api.put<ApiResponse<Cart>>(`/cart/items/${id}`, { quantity }),
  removeItem: (id: string) => api.delete(`/cart/items/${id}`),
  clearCart: () => api.delete('/cart'),
  mergeCart: (sessionId: string) => api.post('/cart/merge', { sessionId }),
};
